import { useState, useEffect, useContext } from 'react';
import { Container, Button, Typography, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import CategoryCard from '../../component/StyledComponents/CreateCards';
import CreateCategories from '../../forms/CreateCategories';
import type { Category } from '../../../types/cards';
import { getAllCategory } from '../../../services/api/Category';
import userContext from '../../../configs/context/context';
import LottieAnimation from '../Vendor/Vendor-ui/lottieAnimation';

const Categories: React.FC = () => {
	const [categories, setCategories] = useState<Category[]>();
	const [openForm, setOpenForm] = useState(false);
	const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
	const [searchTerm, setSearchTerm] = useState('');
	const [loading, setLoading] = useState(true);
	const { Vendorme } = useContext<any>(userContext);

	const permmission = Vendorme?.permissions?.category;

	const fetchCategories = async () => {
		try {
			setLoading(true);
			const data = await getAllCategory();
			if (data.success) {
				setCategories(data?.data || []);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchCategories();
	}, []);

	const handleAddCategory = () => {
		setSelectedCategory(null);
		setOpenForm(true);
	};

	const handleEditCategory = (category: Category) => {
		setSelectedCategory(category);
		setOpenForm(true);
	};

	const handleCloseForm = () => {
		setOpenForm(false);
		setSelectedCategory(null);
	};

	const slug = localStorage.getItem('slug');

	const location = window.location.pathname.split('/');
	let filteredCategories: any[] = [];

	filteredCategories = Array.isArray(categories)
		? categories.filter((category) =>
				category?.categoryName?.name?.toLowerCase().includes(searchTerm.toLowerCase())
			)
		: [];

	return (
		<>
			<Container>
				{!location.includes(slug as string) && (
					<Typography
						gutterBottom
						style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '24px' }}
					>
						Categories
					</Typography>
				)}
				<Typography
					className="d-flex"
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						flexDirection: { xs: 'column', sm: 'row', md: 'row' },
						marginBottom: '10px',
					}}
				>
					<div>
						<span
							style={{
								fontFamily: 'Poppins',
								fontWeight: '400',
								fontSize: '14px',
								color: '#006D48',
							}}
						>
							Manage your product categories, add new categories, and more.
						</span>
					</div>
					<Typography
						sx={{
							width: {
								xs: '100%',
							},
							flexBasis: { xs: 'auto', sm: 'content', md: 'content' },
						}}
					>
						{location.includes(slug as string) && permmission?.read ? (
							<Button
								sx={{
									width: { xs: '100%', sm: 'auto', md: 'auto' },
								}}
								variant="contained"
								color="primary"
								onClick={handleAddCategory}
							>
								Add Categories
							</Button>
						) : (
							!location.includes(slug as string) && (
								<Button
									sx={{
										width: { xs: '100%', sm: 'auto', md: 'auto' },
									}}
									variant="contained"
									color="primary"
									onClick={handleAddCategory}
								>
									Add Categories
								</Button>
							)
						)}
					</Typography>
				</Typography>

				<Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
					<Grid size={{ xs: 12, sm: 12, md: 12 }}>
						<TextField
							sx={{ fontSize: { xs: 14, sm: 16, md: 18 } }}
							label="Search Categories by name"
							variant="outlined"
							margin="none"
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							size="small"
							fullWidth
						/>
					</Grid>
				</Grid>
				<Grid container spacing={3}>
					{!loading && filteredCategories.length === 0 ? (
						<LottieAnimation />
					) : (
						filteredCategories.map((category) => (
							<Grid
								key={category.categoryName._id}
								size={{ xs: 12, sm: 6, md: 3, lg: 3 }}
							>
								<CategoryCard
									category={category}
									onClick={handleEditCategory}
									fetchCategories={fetchCategories}
								/>
							</Grid>
						))
					)}
				</Grid>
				<CreateCategories
					open={openForm}
					handleClose={handleCloseForm}
					fetchCategories={fetchCategories}
					category={selectedCategory}
				/>
			</Container>
			{/* <ToastContainer /> */}
		</>
	);
};

export default Categories;
